import React from 'react';
import { MessageCircle } from 'lucide-react';
export function FloatingWhatsApp() {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', 'WhatsAppClick', {
        location: 'floating'
      });
    }
  };
  return <a href="https://wa.link/sedfbn" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 flex items-center justify-center group" aria-label="Contactar por WhatsApp" data-id="element-145">
      <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 group-hover:opacity-40" data-id="element-146"></div>
      <MessageCircle className="w-8 h-8 relative z-10" data-id="element-147" />
    </a>;
}